import * as Sentry from "@sentry/browser";

/* TODO: use import.meta.env.RAILS_ENV */
export const isDebugMode =
  import.meta.env.MODE == 'development'
if (isDebugMode)
  console.log('DEBUG-MODE',
    import.meta.env.MODE)

const isSentryLogged = !isDebugMode; // ['production', 'stage_minor', 'stage_major'].includes(import.meta.env.MODE)

export const debugLog = (...args) => {
  if (isDebugMode) {
    console.log(...args)
  }
}

export const errorLog = (...args) => {
  if (isDebugMode) {
    console.error(...args)
  }

  if (isSentryLogged) {
    // optionally specify the severity level:
    // "fatal" | "error" | "warning" | "log" | "debug" | "info" (default)
    Sentry.captureMessage(args.flat(), "error");
  }
}